module.exports = __webpack_public_path__ + "img/Backyard-paws-Website-1.d75494ae.webp";